module.exports = __webpack_public_path__ + "img/warning.45b833b1.svg";